module.exports = __webpack_public_path__ + "r6e_trailer_sch-1080p.webm";